module.exports = __webpack_public_path__ + "resources/img/logo_goodsen.7ada5bf251736746e695b86cda18e134.png";